import { useMemo } from "react";
import { useCRMContext } from "../CRMContext"
import { CRMAttributeConfig } from "../types";
import { createSelectSchema, Schema } from "../../../hooks/useSchema";

const Empty: CRMAttributeConfig[] = [];

export const useContactAttributesConfig = () => {
  const ctx = useCRMContext();
  const attributes = ctx.settings.contact_attributes || Empty;

  const schema = useMemo(() => {
    const s = attributes.reduce<Schema>((r,a) => {
      let s: any = { ...a };
      if(s.type === "select") {
        s = createSelectSchema(a.select_options || [], s);
      }
      
      r[a.code] = s;
      return r;
    }, {});
    return s;
  }, [attributes]);

  return {
    attributes,
    schema,
  }
}
